import { createGlobalStyle } from 'styled-components';

const HideHubspotWidget = createGlobalStyle`
  div#hubspot-messages-iframe-container {
    transform: translate(100%, 100%);
  }
`;

export default HideHubspotWidget;
